import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'people-schema/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('peopleSchema/', '')
      .toLowerCase();
  }
}
